import {
    IBaseExtensionCallBackAdapter,
    IBaseExtensionService,
    IBaseExtensionServiceDelegates,
    IEditLifecycleAdapter,
} from '@src/slide/application/service/edit-extension/core/base/interface';
import { onSlideAppReady } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IDocInfoService } from '@src/slide/application/service/doc-service/doc-info-service.interface';
import { isEditableDriveFile, isPreviewDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { LifeCycleType } from '@src/slide/application/service/editor-lifecycle/core/interface';

/**
 * 编辑器对外暴露的接口基类实现
 */
export default class BaseExtensionService implements IBaseExtensionService {
    // extension service依赖的其他服务
    protected services: IBaseExtensionServiceDelegates;
    /**
     * 文档信息
     * @protected
     */
    protected docInfo?: IDocInfoService;
    /**
     * 编辑器加载流程适配器
     */
    protected editLifecycleAdapter?: IEditLifecycleAdapter;
    /**
     * 非编辑入口点击回调适配器
     */
    protected callbackAdapter?: IBaseExtensionCallBackAdapter;

    private hasInit = false;

    public onReady(callback: () => void): void {
        onSlideAppReady(callback);
    }

    /**
     * 是否云编文件
     */
    public isEditableDriveDocs(): boolean {
        return !!isEditableDriveFile();
    }

    /**
     * 是否预览云编文件
     */
    public isPreviewDriveDocs(): boolean {
        return isPreviewDriveFile();
    }

    public isSpecialActivity(): boolean {
        // 子类重写，默认为false
        return false;
    }

    /**
     * 由外部非编能力初始化文档信息service
     * @param docInfoService
     */
    public setDocInfo(docInfoService: IDocInfoService) {
        this.docInfo = docInfoService;
    }
    public getDocInfo(): IDocInfoService | undefined {
        return this.docInfo;
    }

    /**
     * 设置非编辑入口回调Adapter(目前workbench scheme配置了非编辑入口)
     * @param callbackAdapter
     */
    public setCallBackAdapter(callbackAdapter: IBaseExtensionCallBackAdapter): void {
        this.callbackAdapter = callbackAdapter;
    }
    public getCallBackAdapter(): IBaseExtensionCallBackAdapter | undefined {
        return this.callbackAdapter;
    }

    /**
     * 设置生命周期Adapter
     * @param lifecycleAdapter
     */
    public setLifecycleAdapter(lifecycleAdapter: IEditLifecycleAdapter): void {
        this.editLifecycleAdapter = lifecycleAdapter;
    }

    /**
     * 编辑器内部调用，依赖的service
     * @param services
     * @description 内部使用
     */
    public setServiceDelegates(services: IBaseExtensionServiceDelegates): void {
        this.services = services;
        if (!this.hasInit) {
            this.hasInit = true;
            this.onServiceInit();
        }
    }

    /**
     * 依赖的service初始化完成
     * @protected
     */
    protected onServiceInit() {
        const { lifeCycleService } = this.services;
        lifeCycleService.onEvent(LifeCycleType.DATA_READY, () => {
            this.editLifecycleAdapter?.onReady();
        });
        lifeCycleService.onEvent(LifeCycleType.INFRASTRUCTURE_DID_READY, () => {
            this.editLifecycleAdapter?.onInfrastructureDidReady();
        });
        lifeCycleService.onEvent(LifeCycleType.FIRST_SLIDE_RENDER, () => {
            this.editLifecycleAdapter?.onFirstSlideRender();
        });
    }
}
